const legacyQriServiceUrl = () =>
  process.env.REACT_APP_LEGACY_QRI_SERVICE_URL || (process.env.REACT_APP_QRI_SERVICE_URL as string);

const selectQriServiceUrl = (useNewStagingDomain: boolean): string =>
  useNewStagingDomain ? (process.env.REACT_APP_QRI_SERVICE_URL as string) : legacyQriServiceUrl();

let activeQriServiceUrl: string | undefined;

const setQriServiceUrl = (useNewStagingDomain: boolean) => {
  activeQriServiceUrl = selectQriServiceUrl(useNewStagingDomain);
};

const getQriServiceUrl = (): string => activeQriServiceUrl ?? legacyQriServiceUrl();

const resetQriServiceUrl = () => {
  activeQriServiceUrl = undefined;
};

export { getQriServiceUrl, resetQriServiceUrl, selectQriServiceUrl, setQriServiceUrl };
